import React from "react";
import { useBotStore } from "../../stores/botStore";

// Компонент для відображення таблиці логіки ролей
const RoleLogicTable = () => {
  const roleLogic = useBotStore((state) => state.roleLogic);

  return (
    <div id="role-logic-table" className="botsettings-table">
      <div className="table-title">
        <h4>Логіка ролей</h4>
      </div>

      <table>
        <thead>
          <tr>
            <th>ID ролі</th>
            <th>Група</th>
          </tr>
        </thead>
        <tbody>
          {roleLogic.map((role) => (
            <tr key={role.role_id}>
              <td title={`ID: ${role.role_id}`}>{role.role_name}</td>
              <td title={role.description}>
                <span className={`logic-badge logic-${role.logic_group}`}>
                  {role.logic_group === "skip_assignment"
                    ? "Рух по статусу"
                    : "Перепризначення"}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RoleLogicTable;
